<article ref="live_feed_card" class="live-feed-card h-100 d-flex flex-column">
  <div class="d-flex align-items-start justify-content-between gap-3 mb-3">
    <div class="min-w-0">
      <p class="text-uppercase text-secondary text-xxs fw-bold mb-1">Live Feed</p>
      <h6 class="fw-bold mb-1 d-flex align-items-center gap-2">
        <i class="bi bi-camera-video-fill text-danger"></i>
        {{ camera_label }}
      </h6>
      <p class="text-secondary text-xs mb-0 text-truncate">{{ selected_location_name }}</p>
    </div>

    <div class="d-flex align-items-center gap-2 flex-shrink-0">
      <span class="badge rounded-pill bg-success-subtle text-success-emphasis d-inline-flex align-items-center gap-1">
        <span class="bcx-live-dot"></span>
        Live
      </span>

      <button
        type="button"
        class="btn btn-sm btn-outline-secondary rounded-circle d-inline-flex align-items-center justify-content-center live-feed-icon-btn"
        :title="is_fullscreen ? 'Exit fullscreen' : 'View fullscreen'"
        @click="toggle_fullscreen"
      >
        <i :class="is_fullscreen ? 'bi bi-fullscreen-exit' : 'bi bi-fullscreen'"></i>
      </button>
    </div>
  </div>

  <div class="live-feed-frame position-relative overflow-hidden rounded-2 border bg-dark">
    <img
      v-if="stream_url && !image_failed"
      :src="live_feed_src"
      :alt="`${camera_label} footage for ${selected_location_name}`"
      class="live-feed-image"
      @error="mark_feed_failed"
      @load="mark_feed_loaded"
    />

    <div v-else class="live-feed-empty d-flex align-items-center justify-content-center text-center p-4">
      <div>
        <i class="bi bi-camera-video-off fs-2 d-block mb-2"></i>
        <p class="fw-semibold mb-1">Live footage unavailable</p>
        <p class="text-xs mb-0">Check the camera stream or network access.</p>
      </div>
    </div>
  </div>

  <div class="mt-3 pt-3 border-top d-flex align-items-center justify-content-between gap-3">
    <div class="min-w-0">
      <small class="text-uppercase text-secondary text-xxs fw-bold d-block mb-1">Linked Coordinates</small>
      <p class="text-xs fw-semibold mb-0 text-truncate">{{ coordinate_label }}</p>
    </div>

    <button
      type="button"
      class="btn btn-sm btn-outline-danger rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0"
      title="Refresh live feed"
      @click="refresh_feed"
    >
      <i class="bi bi-arrow-clockwise"></i>
    </button>
  </div>
</article>
